import {
	SanityMarketingAboutFund,
	SanityMarketingCaseStudy,
	SanityMarketingCtaPanel
} from 'types/sanity/marketing-components';
import { VentureMarketingPage, VentureMarketingPageResponse } from 'types/sanity/venture-marketing';
import {
	VentureMarketingPageAboutTheFundQuery,
	VentureMarketingPageCaseStudyQuery,
	VentureMarketingPageCtaQuery,
	VentureMarketingPageQuery
} from '@sanity/graphql/queries/venture-marketing-page';
import { flattenSharedFooterDisclaimers } from '@utils/sanity';
import { useQuery } from 'villus';
import { villusClient } from '@utils/villus';

export async function getVentureMarketingPage(): Promise<VentureMarketingPage | null> {
	const { data } = await useQuery<VentureMarketingPageResponse>({
		client: villusClient,
		query: VentureMarketingPageQuery,
		tags: ['venture_marketing_page']
	}).execute();

	const ventureMarketingPage = data?.allVentureMarketingSitePage[0];
	const footerDisclaimers = ventureMarketingPage?.footerDisclaimers ?? [];

	if (ventureMarketingPage && footerDisclaimers.length > 0) {
		ventureMarketingPage.flatFooterDisclaimers = flattenSharedFooterDisclaimers(footerDisclaimers);
	}

	return ventureMarketingPage ?? null;
}

export async function getVentureMarketingPageCta(): Promise<SanityMarketingCtaPanel | null> {
	const { data } = await useQuery<VentureMarketingPageResponse>({
		client: villusClient,
		query: VentureMarketingPageCtaQuery,
		tags: ['venture_marketing_page_cta']
	}).execute();

	return data?.allVentureMarketingSitePage[0] ?? null;
}

export async function getVentureMarketingPageCaseStudy(): Promise<SanityMarketingCaseStudy | null> {
	const { data } = await useQuery<VentureMarketingPageResponse>({
		client: villusClient,
		query: VentureMarketingPageCaseStudyQuery,
		tags: ['venture_marketing_page_case_study']
	}).execute();

	return data?.allVentureMarketingSitePage[0].caseStudyPanel ?? null;
}

export async function getVentureMarketingPageFeaturedFund(): Promise<SanityMarketingAboutFund | null> {
	const { data } = await useQuery<VentureMarketingPageResponse>({
		client: villusClient,
		query: VentureMarketingPageAboutTheFundQuery,
		tags: ['venture_marketing_page_featured_fund']
	}).execute();

	return data?.allVentureMarketingSitePage[0] ?? null;
}
